export const VERSION = "1.0.0";

export enum BRUSH_NAME {
  Text = "Text",
  Pencil = "Pencil",
  Line = "Line",
  Ellipse = "Ellipse",
  Rect = "Rect",
  Triangle = "Triangle",
  Arrow = "Arrow",
  Star = "Star",
}

export enum INTERACTIVE_NAME {
  Move = "Move",
  Hand = "hand",
}

export const FILL_COLOR = "#C4C4C4";
export const LINE_COLOR = "#000000";
export const BASE_COLOR = "rgba(25, 160, 251, 0.3)";
export const STROKE_COLOR = "rgba(25, 160, 251, 1)";
